export default {"src":"/_next/static/media/comment-theme-icon.9ecf323e.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};